import { DatasheetGetDto } from '@common/dto/datasheet/get-dto';
import * as React from 'react';
import { useDatasheetController } from './datasheet';
import { DatasheetUpnListDto } from '@common/dto/datasheet/upn/list';
import { useDatasheetPrintController } from '@modules/datasheets/controllers/datasheet-print';
import { PRINTABLE_RESULT_DATASHEET_ELEMENT_ID, PRINTABLE_DATASHEET_FIELD_ID } from '../../datasheet-printing-settings';
import { generateId } from '@common/utils/common';
import { FormatFieldItem } from '@common/components/format-field-selector';
import {
  GetDatasheetFolderFormats,
  getDatasheetResultFolderFormats as getDatasheetFolderFormatsBase,
} from "@modules/datasheets/services/formats";
import { trDts } from "@modules/datasheets/utils/i18n";
import { getDatasheetFolders } from "@modules/datasheets/services/folders";

import { DatasheetFormatManagementFolder } from '../components/header/format-management.controller';

export type ResultProps = {

};

export const useDatasheetResultMainController = (props: ResultProps) => {
  const [datasheet, setDatasheet] = React.useState<DatasheetGetDto>({
    id: 1,
    name: 'Test Datasheet',
    tabs: Array.from(Array(3)).map((_, index) => ({ id: index+1, name: 'Tab '  + index, texts: [], fields: [] })),
    gridSettings: {
      horizontalGrid: 30,
      verticalGrid: 30,
      showGrid: true,
      showPageBreaks: false,
      snapToGrid: true,
      showEditTabOrder: false,
      showMargins: false,
      marginWidth: 400,
      marginHeight: 300,
    },
  });
  const [currentUpn, setCurrentUpn] = React.useState<DatasheetUpnListDto['id']>();

  const handleUpnChange = React.useCallback((upn: DatasheetUpnListDto['id']) => {
    setCurrentUpn(upn);
  }, []);

  const datasheetController = useDatasheetController({
    datasheet,
    onDatasheetChange: setDatasheet,
  });

  const printableDatasheetHolderId = React.useMemo(() => `${PRINTABLE_RESULT_DATASHEET_ELEMENT_ID}-${generateId()}`, []);

  const getDatasheetFolderFormats = React.useCallback((params: GetDatasheetFolderFormats) => {
    return getDatasheetFolderFormatsBase(params).then((fields) => {
      return fields.map((x): FormatFieldItem => {
        return {
          id: x.id,
          name: x.name,
          folderId: x.folderid,
          imageURL: "gif/format.gif",
          description: ''
        };
      });
    });
  }, []);

  const getFoldersForDatasheet = React.useCallback(() => {
    return getDatasheetFolders().then((x) => [
      {
        imageURL: "gif/dbenthi.gif",
        imageURLSelected: "gif/dbenthi.gif",
        name: trDts("Datasheet Format Folders"),
        id: 0,
        children: x.map((folder): DatasheetFormatManagementFolder => {
          return {
            name: folder.name,
            parentid: folder.parentid,
            id: folder.id,
            imageURL: "gif/folder_open.gif",
            imageURLSelected: "gif/folder_open.gif",
          };
        }),
      },
    ] as Array<DatasheetFormatManagementFolder>);
  }, []);

  const datasheetPrintController = useDatasheetPrintController({
    printableDatasheetHolderId: printableDatasheetHolderId,
    printableDatasheetFieldId: PRINTABLE_DATASHEET_FIELD_ID
  });

  return {
    datasheet,
    handleUpnChange,
    printableDatasheetHolderId,
    getDatasheetFolderFormats,
    getFoldersForDatasheet,
    currentUpn,
    ...datasheetPrintController,
    ...datasheetController,
  };
};